import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import $script from 'scriptjs';

import Forms from '../Forms';
import layout from '../Layout';
import StickyHeader from '../components/StickyHeader';
import NavMobile from '../components/navigation/NavMobile';
import NavDesktopMenu from '../components/navigation/NavDesktopMenu';
import LiveSearch from '../components/search/LiveSearch';
import SearchForm from '../components/search/SearchForm';

export default class StaticHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data.settings;
    this.currency = section.data.currency;
    this.postMessage = section.postMessage;
    this.headerSearch = null;

    this.$scripts = $('[data-scripts]');

    this.$menuToggle = this.$el.find('[data-menu-toggle]');
    this.$cartCount = this.$el.find('[data-header-cart-count]');
    this.$searchField = this.$el.find('[data-live-search]');

    this.$siteNavigation = this.$el.find('[data-site-navigation]');
    this.$desktopNavigation = this.$siteNavigation.find('ul.navmenu-depth-1');
    this.$headerTools = this.$siteNavigation.find('[data-header-actions]');

    this.converter = '[data-currency-converter]';
    this.$converter = $(this.converter);

    this.stickyHeader = new StickyHeader({
      header: this.$el[0],
      menuToggle: this.$menuToggle[0],
      postMessage: this.postMessage,
    }, this.settings);

    this.navMobile = new NavMobile({
      $el: this.$el,
      $toggleOpen: this.$menuToggle,
    });

    this.navDesktop = new NavDesktopMenu(document.querySelector('.site-navigation > [data-navmenu]'));

    this.forms = new Forms(this.$el);

    if (this.settings.live_search.enable) {
      $script(this.$scripts.data('shopify-api-url'), () => {
        this.headerSearch = new LiveSearch({
          $el: this.$searchField,
          $header: this.$el,
        }, this.settings.live_search);
        this.mobileSearchButtonOnClick = e => {
          e.stopPropagation();
          this.headerSearch.open();
        };
        this.mobileSearchButtonEl = section.el.querySelector('[data-mobile-search-button]');

        if (this.mobileSearchButtonEl) {
          this.mobileSearchButtonEl.addEventListener('click', this.mobileSearchButtonOnClick);
        }
      });
    } else {
      this.headerSearch = new SearchForm(this.$searchField);
    }

    if (this.currency.enable) {
      // we assume currencies.js has been loaded
      this._converter();
    }

    $(window).on('cartcount:update', (event, data) => {
      this.$cartCount
        .attr('data-header-cart-count', data.response.item_count)
        .toggleClass('visible', data.response.item_count > 0);
    });
  }

  onSectionSelect() {
    this.stickyHeader.openNavigation();
  }

  onSectionDeselect() {
    this._closeAllNavigation();
  }

  onSectionUnload() {
    this.stickyHeader.unload();
    this.navMobile.unload();
    this.navDesktop.unload();
    this.forms.unload();

    $(window).off('cartcount:update');

    this.headerSearch.unload();

    if (this.currency.enable) {
      this.$converter.off('change.converter');
    }

    if (this.mobileSearchButtonEl) {
      this.mobileSearchButtonEl.removeEventListener('click', this.mobileSearchButtonOnClick);
    }
  }

  onSectionMessage(name) {
    if (name === 'nav:close-all' && layout.isGreaterThanBreakpoint('M')) {
      this._closeAllNavigation();
    }
  }

  onSectionBlockSelect(block) {
    if (!layout.isGreaterThanBreakpoint('M')) {
      return;
    }

    this.stickyHeader.openNavigation(() => {
      this.navDesktop.selectBlock(block.id);
    });
  }

  onSectionBlockDeselect() {
    this._closeAllNavigation();
  }

  _converter() {
    CurrencyConverter.init({
      switcherSelector: this.converter,
      priceSelector: '.money',
      shopCurrency: this.currency.shop_currency,
      defaultCurrency: this.currency.default_currency,
      displayFormat: this.currency.display_format,
      moneyFormat: this.currency.money_format,
      moneyFormatNoCurrency: this.currency.money_format_no_currency,
      moneyFormatCurrency: this.currency.money_format_currency,
    });

    this.$converter.on('change.converter', event => {
      this.$converter.each((index, converter) => {
        if (converter.value !== event.currentTarget.value) {
          converter.value = event.currentTarget.value; // eslint-disable-line no-param-reassign
        }
      });

      CurrencyConverter.setCurrency(event.currentTarget.value);
    });
  }

  _closeAllNavigation() {
    this.navDesktop.closeAllMenus();
  }
}
